import Vue from 'vue'
import vuex from 'vuex';
import App from './App.vue';
import Meta from 'vue-meta';
import createRouter from './router.js'
import { createStore } from './store'
import vueRouter from "vue-router";
import Econfig from './config.js'
import ElementUI from 'element-ui';
import './assets/css/element.css';
Vue.config.productionTip = false;

// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts');
// 引入柱状图
require('echarts/lib/chart/bar');
// 引入折线
require('echarts/lib/chart/line');
// 引入饼状图
require('echarts/lib/chart/pie');
// 引入提示框和标题组件
require('echarts/lib/component/legend');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/lib/component/dataZoom');

Vue.prototype.$echarts = echarts;
Vue.prototype.$Econfig =Econfig.Econfig;
const VueVideoPlayer = require('vue-video-player/dist/ssr');
import './assets/dist/video-js.css'
Vue.use(VueVideoPlayer)

import Vant from 'vant';
import moment from "moment";

Vue.filter('FiltTime',(val) =>{
  return  moment(val).format('DD MMMM YYYY');
});
Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(vueRouter);
Vue.use(vuex);
Vue.use(Meta);


export function createApp () {
    const router = createRouter()
    const store = createStore()
    const app = new Vue({
        router,
        store,
        render: h => h(App)
    })
    return { app, router ,store}
}

